
import React, { useEffect, useState } from 'react';

import { YesBtn, NoBtn, CloseBtn } from './Button';

import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Input, List, ListItem, ListItemText, makeStyles } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import { toast } from 'react-toastify';


const useStyles = makeStyles((theme) => ({
    Title : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    Content : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    ScrollableContent : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        overflowY: 'auto',
        maxHeight: '30vh',
    },
    root : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '16px !important',
        fontWeight : '400 !important',
    },
    rootMob : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '10px !important',
        fontWeight : '400 !important',
    },
    PaperMob : {
        width : '80%',
        backgroundColor : 'black',
        color : 'white',
    },
    Paper : {
        width : '50%',
        backgroundColor : 'black',
        color : 'white',
    },
    Copy : {
        borderRadius: '5px',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'black',
            color : '#fe752f',
            border : 'none'
        },
    },
    listText : {
        overflowX : 'hidden',
        wrap : 'nowrap',
    }

}));

const ReceiverTextPrompt = function ReceiverTextPrompt({ view, open , text, closeBtnCallback }){

    const classes = useStyles();
    const [txt, setTxt] = useState(text);

    var handleClick = () => {
        let copyText1 = document.getElementById("cp");
        copyText1.disabled = false;
        copyText1.select();
        document.execCommand("copy");
        copyText1.disabled = true;
        toast.info("Copied to clipboard!",{
            toastId:"Copied to clipboard!"
        })
    }

    useEffect(() => {
        const textVal = text;
        setTxt(textVal);
        return () => {
            console.log(textVal);
        }
    }, [text])

    

    return(
        <Dialog classes={{ paper : view === 'mobile' ? classes.PaperMob : classes.Paper }} maxWidth='xl' open={open} >
            <DialogTitle disableTypography={true} classes={{ root : classes.Title }} >
                This is the text sent by host: 
                <CloseBtn view="desktop" handleClick={()=>{closeBtnCallback()}} />
            </DialogTitle>
            <DialogContent classes={{ root : classes.ScrollableContent }}>
                <List>
                    <ListItem>
                        <Input style={{color : '#fe752f'}} fullWidth={true} onChange={(e)=>{ setTxt(e.target.value) }} disableUnderline={true} id="cp" value={txt} />
                        <IconButton classes={{root: classes.Copy}} onClick={()=>{ handleClick() }} >
                            <FileCopy />
                            {/* <input id="cp" disabled={true}  value={ text} style={{opacity : 0, width : 1}} /> */}
                        </IconButton>
                    </ListItem>
                </List>
            </DialogContent>
        </Dialog>
    )

}

export default ReceiverTextPrompt;